
import HeroSection from '../../components/feature/HeroSection';
import ServicesSection from '../../components/feature/ServicesSection';
import AboutSection from '../../components/feature/AboutSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import ContactSection from '../../components/feature/ContactSection';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <TestimonialsSection />
      <ContactSection />
    </>
  );
}
